import React from "react";
import Select, { components } from "react-select";
import Arrow from "@material-ui/icons/ArrowDropDown";
import restClient from "../common/restClient";
import tccStyles from "../common/styles";

// custom arrow matching mui styles
const DropdownIndicator = props => {
    return (
        components.DropdownIndicator && (
            <components.DropdownIndicator {...props}>
                <Arrow />
            </components.DropdownIndicator>
        )
    );
};

class AutoCompleteInputOld extends React.Component {
    state = {
        data: [],
        selectValue: null,
        selected: false
    };

    componentDidMount() {
        const { lazy, input } = this.props;
        if (!lazy) {
            const { options } = this.props;
            const params = {
                filter: this.props.filter,
                pagination: { page: 1, perPage: 10000 },
                sort: { field: options.display, order: "asc" }
            };
            restClient("GET_LIST", options.resource, params).then(
                result => {
                    const data = result.data.map(item => {
                        return {
                            value: item.id,
                            label: item[options.display],
                            data: item
                        };
                    });
                    this.setState({ data: data });
                    const defaultSelected =
                        input.value !== "" || undefined
                            ? data.filter(item => {
                                  return this.props.input.value.includes(
                                      item.value
                                  )
                                      ? item
                                      : null;
                              })
                            : [];
                    this.setState({ selectValue: defaultSelected });
                },
                error => {
                    return error;
                }
            );
        } else {
            const { values } = this.props;
            if (values !== null) {
                this.setState({ data: values, selectValue: [] });
            }
        }
    }

    getStyle = () => {
        const { meta } = this.props;
        return {
            menuPortal: provided => ({
                ...provided,
                zIndex: 9999
            }),
            option: (provided, state) => ({
                ...provided,
                color: tccStyles.colors.black,
                padding: 20,
                backgroundColor: state.isSelected
                    ? tccStyles.colors.lightgrey
                    : tccStyles.colors.white,
                ":active": {
                    backgroundColor:
                        state.isSelected || state.isFocused
                            ? tccStyles.colors.lightgrey
                            : tccStyles.colors.white
                },
                ":hover": {
                    backgroundColor: tccStyles.colors.lightgrey
                }
            }),
            control: (provided, state) => ({
                ...provided,
                borderRadius: 0,
                borderTop: state.isFocused ? 0 : 0,
                borderRight: state.isFocused ? 0 : 0,
                borderLeft: state.isFocused ? 0 : 0,
                borderBottom:
                    meta.error &&
                    meta.touched &&
                    this.state.selectValue &&
                    this.state.selectValue.length === 0
                        ? tccStyles.fields.borders.bottomBorderError
                        : tccStyles.fields.borders.bottomBorder,
                // This line disable the blue border
                boxShadow: state.isFocused ? 0 : 0,
                "&:hover":
                    meta.error &&
                    meta.touched &&
                    this.state.selectValue &&
                    this.state.selectValue.length === 0
                        ? tccStyles.fields.borders.bottomBorderError
                        : tccStyles.fields.borders.bottomBorderHover
            }),
            indicatorSeparator: () => ({
                display: "none"
            }),
            dropdownIndicator: (provided, state) => ({
                color: tccStyles.colors.main
            }),
            placeholder: (provided, state) => ({
                ...provided,
                // workaround for matching actual style
                marginLeft: -6.5,
                marginTop: 5
            }),
            menu: (provided, state) => ({
                ...provided,
                position: "absolute",
                zIndex: 1100
            }),
            singleValue: (provided, state) => ({
                ...provided,
                marginTop: 5,
                marginLeft: this.state.selected === false ? -6.5 : 0
            }),
            multiValue: (provided, state) => ({
                ...provided,
                borderRadius: 25,
                height: 32,
                textAlign: "center"
            }),
            multiValueLabel: (provided, state) => ({
                ...provided,
                marginTop: 5,
                color: tccStyles.colors.black
            })
        };
    };

    handleBlur = () => {
        const selected = this.state.selected;
        this.props.input.onBlur();
        this.setState({ selected: !selected });
    };

    handleChange = selected => {
        if (this.props.options.isMulti === true) {
            const values = selected.map(item => {
                return item.value;
            });
            values.length > 0
                ? this.props.input.onChange(values)
                : this.props.input.onChange(null);
        } else {
            this.props.input.onChange(selected.value);
        }
        this.setState({ selectValue: selected });
        if (this.props.onCustomerChanged) {
            this.props.onCustomerChanged(selected.value);
        }
        this.props.callBack && this.props.callBack(selected);
    };

    handleFocus = () => {
        this.setState({ selected: true });
    };

    renderError() {
        return this.props.meta.touched &&
            this.props.meta.error &&
            this.state.selectValue &&
            this.state.selectValue.length === 0 ? (
            <div
                style={{
                    fontSize: "16px",
                    color: tccStyles.colors.error
                }}
            >
                {this.props.meta.error}
            </div>
        ) : null;
    }

    renderLabel() {
        const { label, notRequired } = this.props.options;
        var mylabel = `${label} *`;
        if (notRequired !== undefined && notRequired === true) {
            mylabel = label;
        }
        return (
            <div
                style={{
                    fontSize: "12px",
                    color:
                        this.props.meta.touched &&
                        this.props.meta.error &&
                        this.state.selectValue &&
                        this.state.selectValue.length === 0
                            ? tccStyles.colors.error
                            : tccStyles.colors.main
                }}
            >
                {mylabel}
            </div>
        );
    }

    renderPlaceholder() {
        const { label, notRequired, placeholder } = this.props.options;
        var mylabel = `${label} *`;
        if (placeholder) {
            mylabel = `${placeholder} *`;
        }
        if (notRequired !== undefined && notRequired === true) {
            mylabel = label;
            if (placeholder) {
                mylabel = `${placeholder} *`;
            }
        }
        return (
            <div
                style={{
                    fontSize: "16px",
                    color:
                        this.props.meta.touched &&
                        this.props.meta.error &&
                        this.state.selectValue &&
                        this.state.selectValue.length === 0
                            ? tccStyles.colors.error
                            : tccStyles.colors.main,
                    visibility: this.state.selected === true ? "hidden" : null
                }}
            >
                {mylabel}
            </div>
        );
    }

    render() {
        return (
            <div>
                <div>{this.renderLabel()}</div>
                <Select
                    onFocus={this.handleFocus}
                    components={{ DropdownIndicator }}
                    styles={this.getStyle()}
                    value={this.state.selectValue}
                    onChange={this.handleChange}
                    options={this.state.data}
                    placeholder={this.renderPlaceholder()}
                    onBlur={this.handleBlur}
                    isMulti={this.props.options.isMulti}
                    isClearable={false}
                    isDisabled={this.props.disabled}
                    menuPortalTarget={document.body}
                />
                <div>{this.renderError()}</div>
            </div>
        );
    }
}

export default AutoCompleteInputOld;



// WEBPACK FOOTER //
// ./src/components/AutoCompleteInputOld.js